import { render, staticRenderFns } from "./EditAccessProfile.vue?vue&type=template&id=4034b5be&"
import script from "./EditAccessProfile.vue?vue&type=script&lang=js&"
export * from "./EditAccessProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditAccessProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports